import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Monitor, Copy, Check } from 'lucide-react';

// Desktop-only gate shown to mobile visitors on auth pages
const MobileGatePage: React.FC = () => {
  const [copied, setCopied] = useState(false);

  const handleCopyLink = () => {
    navigator.clipboard.writeText(window.location.href).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    });
  };

  return (
    <div className="min-h-screen bg-william-50 relative overflow-hidden flex items-center justify-center px-6">
      <div className="absolute inset-0 pointer-events-none" aria-hidden="true">
        <div
          className="absolute -top-[20%] -right-[10%] w-[80vw] h-[80vw] max-w-[600px] max-h-[600px] rounded-full opacity-[0.35]"
          style={{ background: 'radial-gradient(circle, #d9eced 0%, transparent 70%)' }}
        />
        <div
          className="absolute -bottom-[30%] -left-[15%] w-[60vw] h-[60vw] max-w-[500px] max-h-[500px] rounded-full opacity-[0.2]"
          style={{ background: 'radial-gradient(circle, #b3d9db 0%, transparent 70%)' }}
        />
      </div>

      <div className="relative z-10 text-center max-w-sm">
        <div className="w-16 h-16 mx-auto mb-6 bg-william-100 rounded-2xl flex items-center justify-center">
          <Monitor size={28} className="text-william-600" />
        </div>

        <h1 className="font-display text-2xl font-bold text-william-800 mb-3">
          Desktop experience
        </h1>
        <p className="text-william-600 mb-8">
          BasiQR is designed for desktop screens. Open this link on your computer to continue.
        </p>

        <button
          onClick={handleCopyLink}
          className="inline-flex items-center gap-2 px-6 py-3 bg-william-600 text-white font-semibold text-sm rounded-[8px] transition-all duration-200 hover:bg-william-700 active:scale-95"
        >
          {copied ? <Check size={16} /> : <Copy size={16} />}
          {copied ? 'Copied!' : 'Copy link'}
        </button>

        {/* Shoppers land here too (a saved piece, a logged-out vault): their
            vault works on a phone (#252 F7). */}
        <p className="mt-8 text-sm text-william-600">
          Saved pieces from a label?{' '}
          <Link to="/vault" className="font-semibold text-william-800 underline underline-offset-2">
            Open your vault
          </Link>
        </p>
      </div>
    </div>
  );
};

export default MobileGatePage;
